export enum Features {
    WEBSITE = 'website',
    ONLINE_SHOPPING_STORE = 'onlineShoppingStore',
    CHATBOT = 'chatbot',
    INVENTORY_MANAGEMENT = 'inventoryManagement',
    IDENTITY = 'identity',
    SYSTEM = 'system',
    OTHER = 'other',
}
